export default "__VITE_ASSET__b36da142__"